import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  a {
    text-decoration: none;
    cursor: default;
  }
`;

export const MenuItem = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  padding: 13.1px 17.1px;
  border-radius: 4px;
  background: transparent;
  border: 1px solid transparent;
  color: ${() => Palette.PrimaryGray._700};
  font-weight: 500;
  font-size: 14px;

  cursor: pointer;

  transition: 0.2s ease-in-out;
  svg {
    transition: 0.2s ease-in-out;
  }

  svg {
    fill: ${() => Palette.PrimaryGray._400};
    margin-right: 17.1px;
  }

  &:hover {
    background: ${() => Palette.PrimaryGray._200};
    color: ${() => Palette.PrimaryGray._900};
    svg {
      fill: ${() => Palette.PrimaryGray._500};
    }
  }
  &:active {
    background: ${() => Palette.PrimaryGray._100};
    color: ${() => Palette.Primary._500};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${() => Palette.Primary._000};
      color: ${() => Palette.PrimaryGray._900};
      border-radius: 4px;
      border: 1px solid ${() => Palette.Primary._300};
      svg {
        fill: ${() => Palette.Primary._500};
      }
      pointer-events: none;
      cursor: default;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      color: ${() => Palette.PrimaryGray._700};
      background: ${() => Palette.PrimaryGray._100};
    `}

        span {
    white-space: nowrap;
  }
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
`;
